/**
 * 角色模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取角色列表
export const roleList = (params) => {
  return req.get('/system/role/list', params);
}

// 获取角色详情
export const roleInfo = (roleId) => {
  return req.get(`/system/role/${roleId}`);
}

// 新增角色
export const roleAdd = (params) => {
  return req.post('/system/role/add', params);
}

// 修改角色信息
export const roleEdit = (params) => {
  return req.post('/system/role/edit', params);
}

// 删除角色信息
export const roleDelete = (roleId) => {
  return req.delete(`/system/role/${roleId}`);
}